import { Provider } from '@angular/core';
import { ROLES_REPOSITORY, RolesStore } from '../stores/roles.store';
import { ParseRoleRepository } from '@telespot/infrastructure/parse';
import Parse from 'parse';

const ROLES_STORE_PROVIDERS: Provider[] = [
  {
    provide: ROLES_REPOSITORY,
    useFactory: () => new ParseRoleRepository(Parse, { useMasterKey: false }),
  },
  RolesStore,
];

/**
 * Generic roles store providers.
 * This providers are used to provide the dependencies for the roles store and the roles related repositories.
 */
export function rolesStoreProviders(): Provider[] {
  return [...ROLES_STORE_PROVIDERS];
}
